import { Bot, Clock, DollarSign, TrendingUp } from "lucide-react";
import { useDashboard } from "@/hooks/queries/dashboard/useDashboard";
import { motion } from "framer-motion";
import { KpiCard } from "@/components/ui/KpiCard";

const currencyBRL = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

export function DashboardROI() {
  const { metrics, metricsLoading } = useDashboard();

  return (
    <motion.section
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="space-y-3"
    >
      <header className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-2.5">
          <div className="flex size-7 shrink-0 items-center justify-center rounded-full bg-brand-soft text-brand">
            <Bot className="size-3.5" strokeWidth={2.25} />
          </div>
          <div>
            <h2 className="text-lg font-semibold tracking-tight text-app-fg-strong">
              ROI da Inteligência Artificial
            </h2>
            <p className="mt-1.5 text-sm text-app-fg-muted">
              Impacto financeiro e operacional gerado pelo seu Copilot autônomo.
            </p>
          </div>
        </div>

        <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-accent-warm-soft px-2.5 py-1 text-[11px] font-medium tracking-wide text-accent-warm-strong">
          <TrendingUp className="size-3" strokeWidth={2.25} />
          High-Ticket
        </span>
      </header>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <KpiCard
          label="Receita Potencial Gerada"
          icon={DollarSign}
          loading={metricsLoading}
          value={metrics?.aiPotentialRevenue == null ? <span className="text-base">Indisponível</span> : currencyBRL.format(metrics.aiPotentialRevenue)}
          helper="100% autônomo via chat"
        />

        <KpiCard
          label="Oportunidades Salvas"
          icon={Clock}
          loading={metricsLoading}
          value={metrics?.outOfHoursAppointments == null ? <span className="text-base">Indisponível</span> :
            <>
              {metrics.outOfHoursAppointments}{" "}
              <span className="text-base font-normal text-app-fg-muted">
                pacientes
              </span>
            </>
          }
          helper="Agendados fora do horário comercial"
        />

        <KpiCard
          label="Agendamentos da IA"
          icon={Bot}
          loading={metricsLoading}
          value={metrics?.aiGeneratedAppointments == null ? <span className="text-base">Indisponível</span> :
            <>
              {metrics.aiGeneratedAppointments}{" "}
              <span className="text-base font-normal text-app-fg-muted">
                consultas
              </span>
            </>
          }
          helper="Sem intervenção humana"
        />
      </div>
    </motion.section>
  );
}
